import React, { memo } from 'react';
import '@tencent/tpm-meeting-active/tea/tea.css';
import "./index.scss";
const TpmComponentWrap = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "ma-t-theme cc-tpm-component-wrap"
  }, children);
};
TpmComponentWrap.displayName = 'cc-tpm-component-wrap';
export default /*#__PURE__*/memo(TpmComponentWrap);